module.exports = __webpack_public_path__ + "img/青海省中医院.6932b144.png";